
export const MLAddressTableFilter = ({search}) => !search? (() => true) : (() => {
    const lowerCase = search.toLowerCase();
    return (r) => (
        r.name.toLowerCase().includes(lowerCase) ||
        r.address.toLowerCase().includes(lowerCase) ||
        r.city.toLowerCase().includes(lowerCase) ||
        r.state.toLowerCase().includes(lowerCase) ||
        r.zip.toLowerCase().startsWith(lowerCase)
    );
})();
